import { Link } from "react-router-dom";
import { categories } from "@/mocks/films";
import { countByCategory } from "@/lib/films";

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16 lg:px-12">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">Browse by genre</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">分类快捷入口</h2>
        </div>
        <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
          按年代与题材进入对应片单，每个分类都配有简介，方便你判断是否合口味。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 lg:gap-4">
        {categories.map((category, index) => (
          <Link
            key={category.key}
            to={`/category?type=${category.key}`}
            className="group flex animate-rise flex-col gap-4 rounded-lg border border-background-300 bg-background-100 p-4 transition-colors hover:border-accent-500/70 hover:bg-background-200 lg:p-5"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-accent-500 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${category.icon} text-lg`} />
            </span>
            <span>
              <span className="block font-heading text-sm font-semibold text-foreground-900">{category.name}</span>
              <span className="mt-1 block font-label text-[11px] text-foreground-500">
                共 {countByCategory(category.key)} 部
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}